global?.modules?.set({
  name: 'header',
  is_booted: false,
  async init() {
    if (this.is_booted) {
      return;
    }
    this.is_booted = true;

    initBurgerMenu();
    headerScroll();

    setTimeout(() => {
      if (window.addWindowScrollEvent) {
        const windowScrollEvent = new Event('windowScroll');

        window.addEventListener('scroll', () => {
          document.dispatchEvent(windowScrollEvent);
        }, { passive: true });
      }
    }, 0);

    function initBurgerMenu() {
      const burger = document.querySelector('.header__burger');
      if (!burger) return;

      document.addEventListener('click', (e) => {
        if (e.target.closest('.header__burger')) {
          bodyLockToggle();
          document.documentElement.classList.toggle('menu-open');
        }
      });
    }

    function headerScroll() {
      const header = document.querySelector('header.header');
      if (!header) return;

      window.addWindowScrollEvent = true;

      const showOnScroll = header.hasAttribute('data-scroll-show');
      const showDelay = parseInt(header.dataset.scrollShow, 10) || 500;
      const scrollStart = parseInt(header.dataset.scroll, 10) || 1;

      let lastScrollTop = 0;
      let showTimeout;

      document.addEventListener('windowScroll', () => {
        const scrollTop = window.scrollY;

        clearTimeout(showTimeout);

        if (scrollTop >= scrollStart) {
          header.classList.add('_header-scroll');

          if (showOnScroll) {
            if (scrollTop > lastScrollTop) {
              header.classList.remove('_header-show');
            } else {
              header.classList.add('_header-show');
            }

            showTimeout = setTimeout(() => {
              header.classList.add('_header-show');
            }, showDelay);
          }
        } else {
          header.classList.remove('_header-scroll', '_header-show');
        }

        lastScrollTop = Math.max(scrollTop, 0);
      });
    }
  }
});